
import * as types from './radActionType';

// Fetch Provider Profile
export const fetchRadProfileRequest = (radId) => ({
    type: types.FETCH_RADPROFILE_REQUEST,
    payload: radId
});
export const fetchRadProfileSuccess = (data) => ({
    type: types.FETCH_RADPROFILE_SUCCESS,
    payload: data
});
export const fetchRadProfileFailure = (error) => ({
    type: types.FETCH_RADPROFILE_FAILURE,
    payload: error
});


// Fetch Radiologist Tasks By Date
export const fetchRadiologistGetRadiologistTasksByDateRequest = (date) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST,
    payload: date
});
export const fetchRadiologistGetRadiologistTasksByDateSuccess = (data) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_SUCCESS,
    payload: data
});
export const fetchRadiologistGetRadiologistTasksByDateFailure = (error) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_FAILURE,
    payload: error
});

// Add Rad Schedule
export const addRadScheduleRequest = () => ({
    type: types.ADD_RAD_SCHEDULE_REQUEST,
});

export const addRadScheduleSuccess = (data) => ({
    type: types.ADD_RAD_SCHEDULE_SUCCESS,
    payload: data
});
export const addRadScheduleFailure = (error) => ({
    type: types.ADD_RAD_SCHEDULE_FAILURE,
    payload: error
});

// Save Rad Schedule
export const saveRadScheduleRequest = (scheduleData, refreshParams = null) => ({
    type: types.SAVE_RAD_SCHEDULE_REQUEST,
    payload: {
        scheduleData,
        refreshParams
    }
});
export const saveRadScheduleSuccess = (data) => ({
    type: types.SAVE_RAD_SCHEDULE_SUCCESS,
    payload: data
});
export const saveRadScheduleFailure = (error) => ({
    type: types.SAVE_RAD_SCHEDULE_FAILURE,
    payload: error
});

// Fetch Rad Profile Associated Facility Matrics
export const fetchRadProfileAssociatedSiteMatricsRequest = (Payload) => ({
    type: types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST,
    payload: Payload
});
export const fetchRadProfileAssociatedSiteMatricsSuccess = (data) => ({
    type: types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_SUCCESS,
    payload: data
});
export const fetchRadProfileAssociatedSiteMatricsFailure = (error) => ({
    type: types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_FAILURE,
    payload: error
});

// Fetch Rad Facility Matrix Dropdown
export const fetchRadSiteMatrixDropdownRequest = (Payload) => ({
    type: types.FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST,
    payload: Payload
});
export const fetchRadSiteMatrixDropdownSuccess = (data) => ({
    type: types.FETCH_RAD_SITE_MATRIX_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchRadSiteMatrixDropdownFailure = (error) => ({
    type: types.FETCH_RAD_SITE_MATRIX_DROPDOWN_FAILURE,
    payload: error
});

// Fetch Get Facility Metrics Child Table
export const fetchRadProfileGetSiteMetricsChildTableRequest = (Payload) => ({
    type: types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST,
    payload: Payload
});
export const fetchRadProfileGetSiteMetricsChildTableSuccess = (data) => ({
    type: types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_SUCCESS,
    payload: data
});
export const fetchRadProfileGetSiteMetricsChildTableFailure = (error) => ({
    type: types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_FAILURE,
    payload: error
});

// Fetch GetRadiologist YTD By ID
export const fetchRadiologistGetRadiologistYTDByIDRequest = (radId) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST,
    payload: radId
});
export const fetchRadiologistGetRadiologistYTDByIDSuccess = (data) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_SUCCESS,
    payload: data
});
export const fetchRadiologistGetRadiologistYTDByIDFailure = (error) => ({
    type: types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_FAILURE,

    payload: error
});
//dropdown bindings in the Update Schedule Information (Start)
export const fetchRadTasksDropdownRequest = (ShiftInputDetailID) => ({
    type: types.FETCH_RAD_DROPDOWN_TASKS_REQUEST,
    payload: ShiftInputDetailID
});
export const fetchRadTasksDropdownSuccess = (data) => ({
    type: types.FETCH_RAD_DROPDOWN_TASKS_SUCCESS,
    payload: data
});
export const fetchRadTasksDropdownFailure = (error) => ({
    type: types.FETCH_RAD_DROPDOWN_TASKS_FAILURE,
    payload: error
});

//dropdown bindings in the Update Schedule Information (End)

// Delete Shift Input Details
export const deleteShiftInputDetailsRequest = (payload) => ({
    type: types.DELETE_SHIFT_INPUT_DETAILS_REQUEST,
    payload: payload
});
export const deleteShiftInputDetailsSuccess = (data) => ({
    type: types.DELETE_SHIFT_INPUT_DETAILS_SUCCESS,
    payload: data
});
export const deleteShiftInputDetailsFailure = (error) => ({
    type: types.DELETE_SHIFT_INPUT_DETAILS_FAILURE,
    payload: error
});

// Fetch Schedules By Date Range
export const fetchSchedulesByDateRangeRequest = (payload) => ({
    type: types.FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST,
    payload: payload
});
export const fetchSchedulesByDateRangeSuccess = (data) => ({
    type: types.FETCH_SCHEDULES_BY_DATE_RANGE_SUCCESS,
    payload: data
});
export const fetchSchedulesByDateRangeFailure = (error) => ({
    type: types.FETCH_SCHEDULES_BY_DATE_RANGE_FAILURE,
    payload: error
});

// Provider Profile Provider Metrics -chart Action - start
export const RadiologistProfileChartDetailsRequest = (payload) => ({
    type: types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_REQUEST,
    payload: payload
});
export const RadiologistProfileChartDetailsSuccess = (data) => ({
    type: types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_SUCCESS,
    payload: data
});
export const RadiologistProfileChartDetailsFailure = (error) => ({
    type: types.GETRADIOLOGIST_PROFILE_CHART_DETAILS_FAILURE,
    payload: error
});

// Rad Profile Download Image
export const downloadRadProfileImageRequest = (payload) => ({
    type: types.DOWNLOAD_RAD_PROFILE_IMAGE_REQUEST,
    payload: payload
});
export const downloadRadProfileImageSuccess = (data) => ({
    type: types.DOWNLOAD_RAD_PROFILE_IMAGE_SUCCESS,
    payload: data
});
export const downloadRadProfileImageFailure = (error) => ({
    type: types.DOWNLOAD_RAD_PROFILE_IMAGE_FAILURE,
    payload: error
});

// Rad Profile Delete Image
export const deleteRadProfileImageRequest = (payload) => ({
    type: types.DELETE_RAD_PROFILE_IMAGE_REQUEST,
    payload: payload
});
export const deleteRadProfileImageSuccess = (data) => ({
    type: types.DELETE_RAD_PROFILE_IMAGE_SUCCESS,
    payload: data
});
export const deleteRadProfileImageFailure = (error) => ({
    type: types.DELETE_RAD_PROFILE_IMAGE_FAILURE,
    payload: error
});

// Rad Profile Save Image
export const saveRadProfileImageRequest = (payload) => ({
    type: types.SAVE_RAD_PROFILE_IMAGE_REQUEST,
    payload: payload
});
export const saveRadProfileImageSuccess = (data) => ({
    type: types.SAVE_RAD_PROFILE_IMAGE_SUCCESS,
    payload: data
});
export const saveRadProfileImageFailure = (error) => ({
    type: types.SAVE_RAD_PROFILE_IMAGE_FAILURE,
    payload: error
});

// Clear Associated Facility Matrics
export const clearRadProfileAssociatedSiteMatrics = () => ({
    type: types.CLEAR_RADPROFILE_ASSOCIATED_SITEMATRICS
});

// Provider Metrics Dropdown
export const fetchRadProviderMetricsDropdownRequest = (payload) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_REQUEST,
    payload: payload
});
export const fetchRadProviderMetricsDropdownSuccess = (data) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_SUCCESS,
    payload: data
});
export const fetchRadProviderMetricsDropdownFailure = (error) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_DROPDOWN_FAILURE,
    payload: error
});

// Provider Metrics Chart Details
export const fetchRadProviderMetricsChartDetailsRequest = (payload) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_REQUEST,
    payload: payload
});
export const fetchRadProviderMetricsChartDetailsSuccess = (data) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_SUCCESS,
    payload: data
});
export const fetchRadProviderMetricsChartDetailsFailure = (error) => ({
    type: types.FETCH_RAD_PROVIDER_METRICS_CHART_DETAILS_FAILURE,
    payload: error
});

// Rad Site Assignment Notes
export const fetchRadSiteAssignmentNotesRequest = (payload) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_REQUEST,
    payload,
});
export const fetchRadSiteAssignmentNotesSuccess = (data) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_SUCCESS,
    payload: data,
});
export const fetchRadSiteAssignmentNotesFailure = (error) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_NOTES_FAILURE,
    payload: error,
});

export const fetchRadSiteAssignmentAllNotesRequest = (payload) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_REQUEST,
    payload,
});
export const fetchRadSiteAssignmentAllNotesSuccess = (data) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_SUCCESS,
    payload: data,
});
export const fetchRadSiteAssignmentAllNotesFailure = (error) => ({
    type: types.FETCH_RAD_SITE_ASSIGNMENT_ALL_NOTES_FAILURE,
    payload: error,
});

export const addRadSiteAssignmentNoteRequest = (payload) => ({
    type: types.ADD_RAD_SITE_ASSIGNMENT_NOTE_REQUEST,
    payload,
});
export const addRadSiteAssignmentNoteSuccess = () => ({
    type: types.ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS,
});
export const addRadSiteAssignmentNoteFailure = (error) => ({
    type: types.ADD_RAD_SITE_ASSIGNMENT_NOTE_FAILURE,
    payload: error,
});

export const clearRadSiteAssignmentNotes = () => ({
    type: types.CLEAR_RAD_SITE_ASSIGNMENT_NOTES,
});
export const clearRadSiteAssignmentAllNotes = () => ({
    type: types.CLEAR_RAD_SITE_ASSIGNMENT_ALL_NOTES,
});
export const resetAddRadSiteAssignmentNoteSuccess = () => ({
    type: types.RESET_ADD_RAD_SITE_ASSIGNMENT_NOTE_SUCCESS,
});